import type { FilterOptions } from '../mapFilters';

const optionHasKeyword = (option: string[], text: string | undefined) =>
  option.some((optionKeyword) =>
    text?.toLocaleLowerCase().includes(optionKeyword.trim().toLocaleLowerCase())
  );

export const filterByKeyword = (
  text: string | undefined,
  { exclude, include }: FilterOptions
) => {
  const flags = {
    shouldInclude: false,
    shouldExclude: false
  };

  // Если есть такой keyword, то не пускаем
  if (exclude.length) {
    flags.shouldExclude = optionHasKeyword(exclude, text);
  }
  // Пускаем, если есть такой keyword в include
  if (include.length) {
    flags.shouldInclude = optionHasKeyword(include, text);
  }

  return flags;
};
